import React from 'react';
import DentalServicePage from './DentalServicePage';

const TeethWhitening = () => {
    // Defined content for Teeth Whitening
    const serviceName = 'Teeth Whitening';
    const serviceTagline = 'Achieve a brighter, more confident smile with professional teeth whitening';

    const whatIsContent = [
        "Professional teeth whitening is a safe, effective cosmetic dental procedure that lightens the natural color of your teeth without removing any of the tooth surface. It's a popular procedure that can significantly improve how your teeth look by reducing discoloration and stains.",
        'Unlike over-the-counter whitening products, professional teeth whitening at Wisdom Dental Clinic uses higher concentration bleaching agents with special safeguards to protect your gums and tooth enamel, providing faster, more dramatic, and longer-lasting results.',
    ];

    const whenRequiredContent = {
        paragraphs: ['Teeth whitening is an excellent option for anyone looking to enhance their smile and boost their confidence.'],
        listIntro: 'You might consider professional teeth whitening if you have:',
        list: [
            'Yellowing or discoloration due to age',
            'Stains from coffee, tea, wine, or tobacco use',
            'Discoloration from certain medications',
            'Fluorosis (white or brown spots from excessive fluoride)',
            'An upcoming special event like a wedding or job interview',
            'A desire for a more youthful, vibrant smile',
            'Tried over-the-counter products with unsatisfactory results',
        ],
        closing:
            "Professional whitening is most effective on natural tooth enamel and may not work on all types of discoloration. During your consultation, we'll discuss your expectations and determine if teeth whitening is right for you.",
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, we offer both in-office and take-home professional whitening options to accommodate your preferences and lifestyle.',
        ],
        listIntro: 'Our teeth whitening services include:',
        list: [
            'Advanced LED-accelerated whitening technology',
            'Custom-fitted trays for at-home treatments',
            'Dental-grade whitening gels unavailable over-the-counter',
            'Professional supervision to ensure safety and effectiveness',
            'Desensitizing treatments for those with sensitive teeth',
            'Long-lasting results with proper maintenance',
        ],
        closing:
            'Before any whitening procedure, we conduct a thorough dental examination to ensure your teeth and gums are healthy. We also offer shade matching to track your progress and achieve your desired level of whiteness.',
    };

    const benefitsContent = [
        {
            title: 'Dramatic Results',
            description: 'Achieve teeth that are several shades whiter in just one office visit',
        },
        {
            title: 'Boosted Confidence',
            description: 'Enjoy the self-esteem that comes with a brighter, more attractive smile',
        },
        {
            title: 'Professional Oversight',
            description: 'Ensure safety and effectiveness with dentist supervision',
        },
        {
            title: 'Customized Treatment',
            description: 'Tailored to your specific needs, goals, and sensitivity levels',
        },
        {
            title: 'Long-Lasting Results',
            description: 'Enjoy a whiter smile for months to years with proper maintenance',
        },
        {
            title: 'Safe Procedure',
            description: "Protection for gums and enamel that over-the-counter products don't provide",
        },
    ];

    const procedureSteps = [
        {
            title: 'Initial Consultation',
            description: 'Dental examination and shade assessment to determine your starting point and goals',
        },
        {
            title: 'Cleaning',
            description: 'Professional cleaning to remove plaque and surface stains before whitening',
        },
        {
            title: 'Preparation',
            description: 'Application of protective barriers to shield your gums and soft tissues',
        },
        {
            title: 'Whitening Application',
            description: 'Application of professional-grade whitening gel to your teeth',
        },
        {
            title: 'Light Activation',
            description: 'For in-office treatment, special LED light may be used to enhance the whitening process',
        },
        {
            title: 'Final Assessment',
            description: 'Evaluation of results and instructions for maintaining your new, brighter smile',
        },
    ];

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
        />
    );
};

export default TeethWhitening;
